import React, { useState, useCallback } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import TextField from "@material-ui/core/TextField";
import makeStyles from "@material-ui/styles/makeStyles";
import { alpha } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Alert from "@material-ui/lab/Alert";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import InputAdornment from "@material-ui/core/InputAdornment";
import EmailIcon from '@material-ui/icons/EmailOutlined';
import LockIcon from '@material-ui/icons/LockOutlined';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import IntlMessages from "src/@jumbo/utils/IntlMessages";
import { login } from "src/api/auth";
import { setAuthUser } from "src/store/slices/auth";
import AuthWrapper from "./AuthWrapper";

const useStyles = makeStyles((theme) => ({
	authThumb: {
		backgroundColor: alpha(theme.palette.primary.main, 0.12),
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: 20,
		width: "100%",
		[theme.breakpoints.up("md")]: {
			width: "50%",
			order: 2,
		},
	},
	titleRoot: {
		marginBottom: 10,
		// fontSize: "2rem",
		// color: theme.palette.text.primary,
	},
	textFieldRoot: {
		// "& .MuiOutlinedInput-notchedOutline": {
		// 	borderColor: alpha(theme.palette.common.dark, 0.12),
		// },
	},
	createAccount: {
		padding: "0.5rem 0",
		fontSize: "1.3rem",
	},
	submitProgress: {
		position: "absolute",
		top: 5,
		left: 46,
	},
	formcontrolLabelRoot: {
		"& .MuiFormControlLabel-label": {
			[theme.breakpoints.down("xs")]: {
				fontSize: 12,
			},
		},
	},
}));
//variant = 'default', 'standard'
const SignIn = ({ variant = "default", wrapperVariant = "default" }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { tenant } = useSelector(({ auth }) => auth);
	console.log("Current tenant.id from Redux:", tenant?.id);
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [isSubmitting, setSubmitting] = useState(false);
	const [error, setError] = useState(null);
	const classes = useStyles({ variant });

	const onSubmit = useCallback(
		async (e) => {
			e.preventDefault();
			setSubmitting(true);

			try {
				setError(null);
				const user = await login({
					email,
					password,
					tenantId: tenant.id,
				});
				dispatch(setAuthUser(user));
				navigate("/dashboard");
			} catch (err) {
				console.error("Error while logging in", err);
				setError(err);
			} finally {
				setSubmitting(false);
			}
		},
		[email, password]
	);

	return (
		<AuthWrapper variant={wrapperVariant}>
			<Box display="flex" flexDirection="column" alignItems="flex-start" style={{ padding: 20, width: '100%' }}>
				<Typography component="h1" variant="h5" align="left" className={classes.titleRoot} style={{ fontWeight: 600, fontSize: 28, color: "#446475", marginBottom: 8 }}>
					Login
				</Typography>
				<Typography align="left" style={{ marginBottom: 24, color: "#666", fontSize: 16 }}>
					Don&apos;t have an account?{' '}
					<NavLink to="/account-type" style={{ color: '#2e6cf6', textDecoration: 'none', fontWeight: 500 }}>Create Account</NavLink>
				</Typography>
				<form onSubmit={onSubmit} style={{ width: '100%', maxWidth: 550 }}>
					<Box mb={3}>
						<Typography variant="body2" style={{ fontWeight: 500, marginBottom: 1 }}>
							Email <span style={{ color: 'red' }}>*</span>
						</Typography>
						<TextField
							placeholder="Input email"
							fullWidth
							autoFocus
							autoComplete="email"
							onChange={(event) => setEmail(event.target.value?.toLowerCase())}
							value={email}
							margin="normal"
							variant="outlined"
							className={classes.textFieldRoot}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<EmailIcon color="action" />
									</InputAdornment>
								),
							}}
						/>
					</Box>
					<Box mb={1}>
						<Typography variant="body2" style={{ fontWeight: 500, marginBottom: 1 }}>
							Password <span style={{ color: 'red' }}>*</span>
						</Typography>
						<TextField
							type={showPassword ? "text" : "password"}
							placeholder="Input password"
							fullWidth
							autoComplete="current-password"
							onChange={(event) => setPassword(event.target.value)}
							value={password}
							margin="normal"
							variant="outlined"
							className={classes.textFieldRoot}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<LockIcon color="action" />
									</InputAdornment>
								),
								endAdornment: (
									<InputAdornment position="end">
										<Box onClick={() => setShowPassword((show) => !show)} style={{ cursor: 'pointer' }}>
											{showPassword ? <VisibilityOff color="action" /> : <Visibility color="action" />}
										</Box>
									</InputAdornment>
								),
							}}
						/>
					</Box>
					<Box mb={3} width="100%" display="flex" justifyContent="flex-end">
						<NavLink to="/forgot-password" style={{ color: '#2e6cf6', textDecoration: 'none', fontSize: 14, fontWeight: 500 }}>
							Forgot password?
						</NavLink>
					</Box>
					<Button type="submit" variant="contained" color="primary" fullWidth disabled={isSubmitting || !email || !password} style={{ height: 48, fontSize: 18, fontWeight: 600 }}>
						Login
						{isSubmitting && <CircularProgress color="inherit" size={20} style={{ marginLeft: 8 }} />}
					</Button>
					{error && (
						<Box mt={2} width="100%">
							<Alert severity="error">{error}</Alert>
						</Box>
					)}
				</form>
			</Box>
		</AuthWrapper>
	);
};

export default SignIn;
